import * as React from 'react';

interface IIconProps extends React.HTMLProps<SVGSVGElement> {
}

export function EyeClosed(props: IIconProps) {
  //tslint:disable max-line-length
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="#2B87DB" fillRule="nonzero">
        <path d="M14.6 5.6l-8.2 8.2c.5.1 1.1.2 1.6.2 3.6 0 6.4-3.1 7.6-4.9.5-.7.5-1.6 0-2.3-.2-.3-.6-.7-1-1.2zM14.3.3L11.6 3C10.5 2.4 9.3 2 8 2 4.4 2 1.6 5.1.4 6.9c-.5.7-.5 1.6 0 2.2.5.8 1.4 1.8 2.4 2.7L.3 14.3c-.4.4-.4 1 0 1.4.2.2.4.3.7.3.3 0 .5-.1.7-.3l14-14c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0zm-9 9C5.1 8.9 5 8.5 5 8c0-1.7 1.3-3 3-3 .5 0 .9.1 1.3.3l-4 4z"/>
    </g>
  </svg>
  );
  //tslint:enable max-line-length
}

export function EyeOpened(props: IIconProps) {
  //tslint:disable max-line-length
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10">
      <path fill="#2B87DB" fillRule="nonzero" d="M15.878 4.604C15.75 4.416 12.699 0 8 0 3.277 0 .247 4.418.12 4.606a.702.702 0 0 0 .002.79C.25 5.584 3.302 10 8 10c4.675 0 7.748-4.414 7.877-4.601a.704.704 0 0 0 .001-.795zM8 8.57C4.837 8.571 2.447 6.003 1.634 5c.479-.595 1.51-1.733 2.927-2.565-.13.366-.196.75-.197 1.137 0 1.97 1.631 3.572 3.636 3.572s3.637-1.602 3.637-3.572a3.444 3.444 0 0 0-.195-1.13c1.41.832 2.441 1.965 2.922 2.558-.82 1.006-3.22 3.572-6.364 3.572z"/>
    </svg>
  );
  //tslint:enable max-line-length
}
